// Pays du filtre de la liste : les plus fournis d'abord, tous sur demande ou par recherche, et jamais un pays
// filtré qui disparaîtrait de la colonne.
import { countryName } from "./projectUtils";

export type CountryCount = { id: string; nb_projects: number };

const fold = (text: string) =>
  text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

/** Pays filtrés, qu'ils viennent d'un bouton (`country`) ou d'une liste de l'assistant (`country@in`). */
export const activeCountries = (filter: Record<string, unknown>): string[] => {
  if (typeof filter.country === "string") return [filter.country];
  const list = filter["country@in"];
  if (typeof list !== "string") return [];
  return list
    .replace(/^\(|\)$/g, "")
    .split(",")
    .map((code) => code.replace(/"/g, "").trim())
    .filter(Boolean);
};

/** Pays à afficher, dans l'ordre reçu (du plus fourni au moins fourni). */
export const visibleCountries = <T extends CountryCount>(
  rows: T[],
  {
    max,
    expanded = false,
    query = "",
    active = [],
    locale = "fr",
  }: {
    max: number;
    expanded?: boolean;
    query?: string;
    active?: string[];
    locale?: string;
  },
): T[] => {
  const wanted = fold(query);
  if (wanted)
    return rows.filter(
      (row) =>
        fold(countryName(row.id, locale)).includes(wanted) ||
        row.id.toLowerCase() === wanted,
    );
  if (expanded) return rows;
  return rows.filter((row, index) => index < max || active.includes(row.id));
};
